import {useMemo} from 'react';

import {
  hasCmsPrimaryItems,
  isLegacyNavigationMenu,
  mapNavigationPrimaryTabs,
} from '@amblique/king-living/app/utils/navigation-primary-tabs';

/**
 * Derive primary nav tabs from the Contentful NavigationMenu.
 * Must not call `useIntl` — App uses this hook above `<IntlProvider>`.
 *
 * Header 2.0 only when CMS has Primary Items. Missing/empty → Header 1.0
 * (legacy hover row). Do not hold v2 during shell load — that hides the
 * v1 row (`megaMenuDesktopWrapper` is 0×0 on v2).
 *
 * @param {Object|null|undefined} navigationMenu
 * @returns {{primaryTabs: Array, hasCmsPrimaryItems: boolean, isLegacyNav: boolean}}
 */
export const useNavigationPrimaryTabs = (navigationMenu) => {
  return useMemo(
    () => {
      const cmsPrimary = hasCmsPrimaryItems(navigationMenu);

      return {
        primaryTabs: cmsPrimary ? mapNavigationPrimaryTabs(navigationMenu) : [],
        hasCmsPrimaryItems: cmsPrimary,
        isLegacyNav: isLegacyNavigationMenu(navigationMenu),
      };
    },
    [navigationMenu]
  );
};
